<template>
    <div :class="'Vue_tooltip '+side">
        {{text}}
    </div>
</template>

<script>
export default {
    props:['text', 'side'],
    mounted () {
        $( ".vue_show_tooltip" ).hover(
            function() {
                $(this).find('.vue_tooltip').removeClass('hide')
                $(this).find('.vue_tooltip').addClass('show')
            }, function() {
                $(this).find('.vue_tooltip').removeClass('show')
                $(this).find('.vue_tooltip').addClass('hide')
            }
        );
    },
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700&display=swap');
.hide{
    display: none;
}
.show{
    display: block;
}
.r{
    right: 0;
    @media only screen and (max-width: 1050px) {
        left: 0 !important;
    }
}
.l{
    left: 0;
}
.Vue_tooltip{  
    z-index: 1000;
    transition: .5s;  
    position: absolute;
    top: 33px;
    width: 207px;
    min-width: 207px;
    height: auto;
    background: rgba(54, 58, 83, 0.88);
    border-radius: 6px;
    font-family: 'Montserrat', sans-serif;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    color: #FFFFFF;
    text-transform: none;
    padding: 9px 12px;
    @media only screen and (max-width: 1000px) {
        display: none !important;
    }
}
</style>